import { IconButton } from '../../../../../components/IconButton';
import React from 'react';
import { InputFormField } from '../../../../../components/InputFormField';
import classNames from 'classnames';

interface PropTypes {
  reasons: string[];
  duplicates: string[];
  readonly?: boolean;
  singleInput?: boolean;
  setReasons?: (reasons: string[]) => void;
}

interface ReasonInputProps extends PropTypes {
  reason: string;
  index: number;
}

function ReasonInput(props: ReasonInputProps) {
  function removeReason(index: number) {
    const newReasons = [...props.reasons];
    newReasons.splice(index, 1);
    props.setReasons(newReasons);
  }

  function updateReason(value: string, index: number) {
    const newReasons = [...props.reasons];
    newReasons[index] = value;
    props.setReasons(newReasons);
  }

  const error =
    'This reason already exists. Change the name before proceeding.';
  const isDuplicated =
    props.duplicates?.find((d) => d === props.reason) != null;
  return (
    <div className={classNames({ 'd-flex': !props.singleInput }, 'mb-2h')}>
      <InputFormField
        setValueOnChange={(value: string) => updateReason(value, props.index)}
        classNames='fs-5'
        hideHeader
        type='text'
        defaultValue={props.reason}
        invalidInput={!props.singleInput && isDuplicated}
        error={props.singleInput && isDuplicated && error}
        maxLength={65}
        showMaxLengthCounter={props.singleInput}
        placeholder='Insert Reason Name'
      />
      {!props.singleInput && (
        <IconButton
          color='borderless'
          buttonClass='text-dark-200 ms-2'
          iconName='bi-trash'
          disabled={props.reasons.length === 1}
          onClick={() => removeReason(props.index)}
        />
      )}
    </div>
  );
}

export function ReasonsInput(props: PropTypes) {
  const handleAddInput = () => {
    props.setReasons([...props.reasons, '']);
  };

  return (
    <>
      {props.reasons.map((reason, index) => (
        <ReasonInput key={index} index={index} reason={reason} {...props} />
      ))}
      {!props.singleInput && (
        <div className='mt-1'>
          <IconButton
            color='borderless'
            iconName='bi-plus-circle'
            buttonText='Add Requisition Reason'
            onClick={handleAddInput}
          />
        </div>
      )}
    </>
  );
}
